// @owners { team: patients }
import { type BaseIconName } from '@alto/design-library-tokens';
import { PressableAltoIcon, Row } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { type OriginName } from '~shared/lib/analytics/src/getOrigin';
import { useFetchAllNotifications } from '../../alto-assistant';
import { Dot } from '../../navigation';

type Props = {
  readonly origin: OriginName;
  readonly iconName?: BaseIconName;
};

export const NotificationNavIcon = ({ origin, iconName = 'bell' }: Props) => {
  const { unreadNotificationsCount } = useFetchAllNotifications();
  const { navigate } = useNavigation();

  return (
    <Row right>
      {unreadNotificationsCount > 0 && (
        <Dot
          accessibilityLabel="Unread messages"
          withAnimation
          topPosition={0}
        />
      )}
      <PressableAltoIcon
        accessibilityLabel="Notification Center"
        onPress={() => {
          navigate('RouteNotificationCenter', { origin });
        }}
        testID="notification-nav-icon"
        name={iconName}
      />
    </Row>
  );
};
